import { render, staticRenderFns } from "./step-two.vue?vue&type=template&id=471e5c4b&"
import script from "./step-two.vue?vue&type=script&lang=js&"
export * from "./step-two.vue?vue&type=script&lang=js&"
import style0 from "./step-two.vue?vue&type=style&index=0&id=471e5c4b&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports